import { Component, OnInit, Input } from '@angular/core';
import { AppBaseComponent } from '@utils';
import { RegistrationService } from '@services';
import { ControlContainer, FormBuilder } from '@angular/forms';

@Component({
  selector: 'app-applicant-information',
  templateUrl: './applicant-information.component.html',
  styleUrls: ['./applicant-information.component.scss'],
})
export class ApplicantInformationComponent
  extends AppBaseComponent
  implements OnInit
{
  [x: string]: any;
  @Input() title!: string;
  @Input() stateInput: boolean = false;
  @Input() tramiteActual: any;
  @Input() personaEncontrada: any;
  @Input() tramiteObject: any;
  public informationPersonal; //: FormGroup;

  tiposDocumentos: any[] = [];

  @Input() isLegalPerson: boolean;
  personType: any;
  constructor(public fb: FormBuilder,
    private controlContainer: ControlContainer,
    private registrationService: RegistrationService) {
    super();
  }

  ngOnInit(): void {
    this.informationPersonal = this.controlContainer.control;
    this.informationPersonal = this.informationPersonal.controls['informationPersonal'];
    this.listDocument();
  }

  listDocument() {
    this.registrationService.getTipoIdentificacion().subscribe((resp) => {
      this.tiposDocumentos = resp.data;
    });
  }


}
